import React from "react";
import styled from "styled-components/macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

const UnitScaleButton = ({ onClick }) => {
  return (
    <Wrapper>
      <WrapperIcon
        onClick={() => {
          onClick && onClick("bigger");
        }}
      >
        <FontAwesomeIcon color={"#FFFFFF"} icon={faPlus} />
      </WrapperIcon>
      <WrapperIcon
        onClick={() => {
          onClick && onClick("smaller");
        }}
      >
        <FontAwesomeIcon color={"#FFFFFF"} icon={faMinus} />
      </WrapperIcon>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 43px;
  flex-direction: column;
  border-radius: 30px;
  box-shadow: 2px 2px 5px #bababa;
  background-color: #a1a0a0;
  opacity: 0.45;
  align-items: center;
`;
const WrapperIcon = styled.div`
  display: flex;
  position: relative;
  padding: 15px;
`;

export { UnitScaleButton };
